import { ControlType, FormField, FormFieldInit } from "../base";

export abstract class FormFieldDate extends FormField {
  override controlType = ControlType.DATE;

  static readonly DAY_INPUT_NAME = "day";
  static readonly MONTH_INPUT_NAME = "month";
  static readonly YEAR_INPUT_NAME = "year";

  public override initialValue?: Date | undefined;

  constructor(init: FormFieldInit<FormFieldDate>) {
    super(init);

    this.initialValue = init.initialValue;
  }
}
